import React from "react";
import { BaseComponent, HRule, Row, Portion } from "reactised-fictoan";

import MdRender from "../Common/MdRender";
import HelpFooterBBPS from "../Common/HelpFooterBBPS";

class CouMoved extends React.PureComponent {
    componentDidMount() {
        document.title = "BBPS COU docs have moved — Setu";

        window.scrollTo(0, 0);
    }

    render() {
        return (
            <BaseComponent Element="article" id="page-fastag">
                <Row
                    sidePadding="large"
                    id="getting-started"
                    className="content-padding-large"
                >
                    <Portion>
                        <MdRender contentKey="couMoved"></MdRender>
                    </Portion>
                </Row>

                <HRule thin bgColor="slate-40" sideMargin="large" />
                <HelpFooterBBPS></HelpFooterBBPS>
            </BaseComponent>
        );
    }
}

export default CouMoved;
